import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
    selectedOption: null,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setSelectedOption(state, payload) {
      state.selectedOption = payload
    }
  },
  actions: {
    async loadAllByQuestionnaireID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("outcomePlanQuestionnaireOptions/byQuestionID", { params: { id: id } });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setListLoading", true);
      let list = await api.get("outcomePlanQuestionnaireOptions/byID", { params: { id: id } });
      commit("setSelectedOption", list.data[0]);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("outcomePlanQuestionnaireOptions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });

      dispatch("loadAllByQuestionnaireID", payload.outcomePlanQuestionnaire_id);
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("outcomePlanQuestionnaireOptions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });

      dispatch("loadAllByQuestionnaireID", payload.outcomePlanQuestionnaire_id);
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    selectedOption(state) {
      return state.selectedOption
    }
  }
}
